module.exports = __webpack_public_path__ + "static/img/phone.e6afbbeb.svg";